import { useEffect, useState, useRef, useLayoutEffect, useCallback } from 'react'
import { debounce } from 'lodash'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'
import { PageLink, PageTitle } from '../../_metronic/layout/core'
import { deleteInvoiceandSales } from '../apis/Loadalltabledata'
import { KTCard } from '../../_metronic/helpers'
import { KTCardBody } from '../../_metronic/helpers'
import { KTSVG, toAbsoluteUrl } from '../../_metronic/helpers'
import { Maintable } from '../tables/Maintable'
import { useMemo } from 'react'
import { Addexpenses } from './modals/Addexpenses'
import { Deleteinvoice } from './modals/Deleteinvoice'
import { Updateinvoice } from './modals/Updateinvoice'
import LoadingBar from 'react-top-loading-bar'
import { getSalesInvoicesandsales } from '../apis/Loadalltabledata'
import { useWindowWidth } from '@react-hook/window-size/throttled'
import {
  useSalesInvoicesusequery,
  useDeletesalesinvoices,
  useSumsalesInvoicesusequery,
  useSumexpenseusequery,
  useSumprofitorlossusequery,
  useSalesInvoicespaymenttypes,
  useFrequentlysold,
  useFrequentlysold2,
  useAllproducts,
  useAllproducts2,
  useTodaysCashFloat,
} from '../contextProviders/Atomqueryprovider'
import CountUp from 'react-countup'
import '../css/popover.css'
import { Column } from 'react-table'
import { useAuth } from '../../app/modules/auth'
import { ItemsSummary } from '../topdashboard/ItemsSummary'
import { useMutation, useQueryClient } from 'react-query'
import io from 'socket.io-client'
import { Getfirsttwowords, Getnumbersinstring } from '../helpers/useStringhelper'
import { Addsales } from './modals/Addsales'
import { useUserroles } from '../../Atom/contextProviders/Atomqueryprovider'
import dayjs from 'dayjs'
import relativeTime from 'dayjs/plugin/relativeTime'
import calendar from 'dayjs/plugin/calendar'
import localizedFormat from 'dayjs/plugin/localizedFormat'

import useNumberSequence from '../helpers/useKeySequence'
import { Mpesatransaction } from './modals/Mpesatransaction'
import useKeySequence from '../helpers/useKeySequence'
import { Cashfloat } from './modals/Cashfloat'
import { useDashboard } from '../contextProviders/Dashboardcontext'
import { Addcustomer } from '../customers/modals/Addcutomer'


const CURRENCY_APP = process.env.REACT_APP_CURRENCY
const OPENING_TIME = process.env.REACT_APP_OPENING_TIME
const OPENING_TIME_HOURS = process.env.REACT_APP_OPENING_TIME_HOURS
const OPENING_TIME_MINUTES = process.env.REACT_APP_OPENING_TIME_MINUTES
const OPENING_TIME_SECONDS = process.env.REACT_APP_OPENING_TIME_SECONDS
const PIC_QUANTITIES = process.env.REACT_APP_QUANTITIES_PICS
// Hook
dayjs.extend(relativeTime)
dayjs.extend(calendar)
dayjs.extend(localizedFormat)

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/home',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const moment = require('moment-timezone')
const addCommas = (num: any) => {
  // Handle undefined, null, or non-numeric values
  if (num === undefined || num === null || num === '') {
    return '0'
  }

  // Convert to number if it's a string
  const numValue = typeof num === 'string' ? parseFloat(num) : num

  // Check if it's a valid number
  if (isNaN(numValue)) {
    return '0'
  }

  return numValue.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}
const socket = io('possocket.27mirrors.com')

function isNegative(num: any) {
  if (Math.sign(num) === -1) {
    return true
  }

  return false
}

const Home = () => {
  const myRef: any = useRef()
  const myRef2: any = useRef()
  const refloadingbar: any = useRef(null)
  const queryClient = useQueryClient()
  const myRefsearch: any = useRef()
  const myRefexpenses: any = useRef()
  const myRefupdate: any = useRef()
  const { currentUser, logout } = useAuth()
  const truncate = require('truncate')
  const [modalshow, setModalshow] = useState(false)
  const [modalfrequentsaleshow, setModalfrequentsaleshow] = useState(false)
  const [modalshowexpenses, setModalshowexpenses] = useState(false)
  const [modalshowupdate, setModalshowupdate] = useState(false)
  const [modalshowdelete, setModalshowdelete] = useState(false)
  const [modalshowmpesa, setModalshowmpesa] = useState(false)
  const [statedeletinginvoice, setStatedeletinginvoice] = useState(false)
  const [invoicetodelete, setInvoicetodelete] = useState<any>('')
  const [invoiceupdate, setInvoiceupdate] = useState<string>('')
  const [paginationsize, setPaginationsize] = useState<number>(10)
  const [paginationsizefrequent, setPaginationsizefrequent] = useState<number>(12)
  const [paginationsizefrequent2, setPaginationsizefrequent2] = useState<number>(999999999)
  const [startlimit, setStartlimit] = useState<number>(0)
  const [modalCustomershow, setModalCustomershow] = useState(false)
  const [startlimitsumdash, setStartlimitsumdash] = useState<number>(0)
  const [database_limitsumdash, setDatabase_limitsumdash] = useState<number>(7)
  const [statusssumdash, setStatussumdash] = useState<string>('PAID')
  const [statusnow, setStatusnow] = useState<boolean>(false)
  const [statusnow2, setStatusnow2] = useState<boolean>(false)
  const [itemto_order, setItemto_order] = useState<string>('date_recorded')
  const [desorasc, setDesorasc] = useState<string>('DESC')
  const [serversort, setServersort] = useState<any>([])
  const [mpesatransaction, setMpesatransaction] = useState<any>({})
  const [mpesapayload, setMpesapayload] = useState<boolean>(false)
  const [search_item, setSearch_item] = useState<string>('%')
  const [pageCount, setPageCount] = useState<number>(0)
  const [sumsalesInvoicesdatanew, setSumsalesInvoicesdatanew] = useState<any>([])
  const [sumexpensedatanew, setSumexpensedatanew] = useState<any>([])
  const [sumprofitorlossdatanew, setSumprofitorlossdatanew] = useState<any>([])
  const [frequentsaleDetails, setFrequentsaleDetails] = useState<any>([])
  const [allproductsdetails, setAllproductsDetails] = useState<any>([])
  const [frequentsaledoubleentry, setFrequentsaledoubleentry] = useState<any>(false)
  const [hiddencolumnsmade, setHiddencolumnsmade] = useState<any>(['sales_info'])
  const [movetofirstpage, setMovetofirstpage] = useState<boolean>(false)
  const onlyWidth = useWindowWidth()
  const [modalshowcashfloat, setModalshowcashfloat] = useState(false)
  const { showDashboard, toggleDashboard } = useDashboard();
  const [invoiceToAddItem, setInvoiceToAddItem] = useState<any>(null)
  const [modalshowadditems, setModalshowadditems] = useState(false)
  const myRefcashfloat: any = useRef()
  const {
    isLoading: userrolesloading,
    isSuccess: userrolessuccess,
    data: userrolesdata,
  } = useUserroles(Number(currentUser?.user_role_id))
  const [businessDate, setBusinessDate] = useState<string>('')
  const [currentFloat, setCurrentFloat] = useState<any>(null)

  const {
    isLoading: todaysFloatLoading,
    isSuccess: todaysFloatSuccess,
    data: todaysFloatData,
    refetch: todaysFloatRefetch,
  } = useTodaysCashFloat(
    Number(currentUser?.user_id),
    businessDate,
    { enabled: !!businessDate }
  )

  const getBusinessDate = (): string => {
    try {
      const now = dayjs();
      const today = now.format('YYYY-MM-DD');
      const todayOpeningTime = dayjs(`${today} ${OPENING_TIME}`);

      return now.isBefore(todayOpeningTime)
        ? now.subtract(1, 'day').format('YYYY-MM-DD')
        : today;
    } catch (error) {
      console.error('Error calculating business date:', error);
      return dayjs().format('YYYY-MM-DD');
    }
  };

  const getBusinessDateFromTimestamp = (createdAt: string): string => {
    try {
      const createdDate = dayjs(createdAt);
      const createdDay = createdDate.format('YYYY-MM-DD');
      const createdDayOpeningTime = dayjs(`${createdDay} ${OPENING_TIME}`);

      return createdDate.isBefore(createdDayOpeningTime)
        ? createdDate.subtract(1, 'day').format('YYYY-MM-DD')
        : createdDay;
    } catch (error) {
      console.error('Error calculating business date from timestamp:', error);
      return '';
    }
  };

  const isCurrentBusinessDay = () => {
    if (!businessDate) return false;
    return businessDate === getBusinessDate();
  };

  const {
    isLoading: salesinvoiceisloading,
    isSuccess: salesinvoicedsuccess,
    data: salesinvoicedata,
    isPreviousData: salesinvoiceispreviousdata,
    status: salesinvoicestatus,
    refetch: salesinvoicerefetch,
  } = useSalesInvoicesusequery(
    Number(currentUser?.user_id),
    startlimit,
    paginationsize,
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    itemto_order,
    desorasc,
    search_item,
    ['PAID', 'CREDIT', 'NOT PAID', 'PARTIAL']
  )

  const {
    isLoading: frequentlysoldloading,
    isSuccess: frequentlysoldsuccess,
    data: frequentlysolddata,
    isPreviousData: frequentlysoldispreviousdata,
    status: frequentlysoldstatus,
    refetch: frequentlysoldrefetch,
  } = useFrequentlysold(paginationsizefrequent)

  const {
    isLoading: allproductsloading,
    isSuccess: allproductssuccess,
    data: allproductsdata,
    status: allproductsstatus,
    isPreviousData: allproductspreviousdata,
    isRefetching: allproductsrefetching,
    refetch: allproductsrefetch,
  } = useAllproducts2(0, 999999999, 'product_name', 'ASC', '%')

  const isUserAdmin = () => {
    if (!userrolessuccess || !userrolesdata?.data) return false
    // Assuming the role data has a field like 'role_name' or 'is_admin'
    // Adjust this condition based on your actual role data structure
    return userrolesdata.data.role_name === 'Admin' || userrolesdata.data.is_admin === true
  }

  const showModalcashfloat = () => {
    setModalshowcashfloat(true)
    myRefcashfloat.current.Resetmodalcashfloatvalues()
  }

  useEffect(() => {
    const calculatedDate = getBusinessDate();
    setBusinessDate(calculatedDate);
  }, []);

  useEffect(() => {
    if (todaysFloatSuccess && businessDate) {
      let allFloats = [];

      // Handle different possible data structures
      if (Array.isArray(todaysFloatData)) {
        allFloats = todaysFloatData;
      } else if (todaysFloatData && Array.isArray(todaysFloatData.data)) {
        allFloats = todaysFloatData.data;
      } else if (todaysFloatData && typeof todaysFloatData === 'object') {
        allFloats = Object.values(todaysFloatData).filter(item =>
          item && typeof item === 'object' && item.created_at
        );
      }

      // Filter floats for current business date
      const todaysFloats = allFloats.filter((float: any) => {
        if (!float?.created_at) return false;
        const floatBusinessDate = getBusinessDateFromTimestamp(float.created_at);
        return floatBusinessDate === businessDate;
      });

      if (todaysFloats.length > 0) {
        const mostRecent = todaysFloats.sort((a: any, b: any) =>
          dayjs(b.created_at).unix() - dayjs(a.created_at).unix()
        )[0];

        setCurrentFloat(mostRecent);
      } else {
        setCurrentFloat(null);
      }
    }
  }, [todaysFloatSuccess, todaysFloatData, businessDate]);

  useEffect(() => {
    if (!salesinvoiceispreviousdata) {
      ; (async () => {

        await refloadingbar.current?.continuousStart()

        queryClient.prefetchQuery(
          ['salesInvoicesusequery', startlimit + paginationsize, paginationsize],
          () =>
            getSalesInvoicesandsales(
              Number(currentUser?.user_id),
              startlimit + paginationsize,
              paginationsize,
              new Date(
                dayjs
                  .unix(
                    dayjs(
                      dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') +
                      OPENING_TIME
                    ).unix()
                  )
                  .format('YYYY-MM-DD hh:mm')
              ),
              new Date(
                dayjs(
                  dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME
                ).format('YYYY-MM-DD hh:mm')
              ),
              itemto_order,
              desorasc,
              search_item,
              ['PAID', 'CREDIT', 'NOT PAID', 'PARTIAL']
            )
        )
      })().finally(refloadingbar.current.complete())
    }
  }, [
    salesinvoiceispreviousdata,
    startlimit,
    paginationsize,
    queryClient,
    itemto_order,
    desorasc,
    search_item,
  ])

  useEffect(() => {
    const fetchData = async () => {
      try {

        await refloadingbar.current?.continuousStart()

        await salesinvoicerefetch()
      } catch (error) {
        console.log(error)
      } finally {
        refloadingbar.current.complete()
      }
    }
    fetchData()
  }, [itemto_order, desorasc, search_item])

  useEffect(() => {
    const handleValueChange = () => {
      if (myRefsearch.current.value === '' && myRefsearch.current === document.activeElement) {
        setSearch_item('%')
        setPaginationsize(10)
        setStartlimit(0)
        setItemto_order('date_recorded')
        setDesorasc('DESC')
        setMovetofirstpage(true)
      }
    }

    const refSearch = myRefsearch.current
    if (refSearch) {
      refSearch.addEventListener('input', handleValueChange)
    }

    return () => {
      if (refSearch) {
        refSearch.removeEventListener('input', handleValueChange)
      }
    }
  }, [])

  useEffect(() => {
    if (serversort.length > 0) {
      setItemto_order(serversort.map((x: any) => x.id)[0])
      setDesorasc(serversort.map((x: any) => x.desc)[0] ? 'DESC' : 'ASC')
    } else {
      setItemto_order('date_recorded')
      setDesorasc('DESC')
    }
  }, [serversort])

  const handleAddItemToInvoice = (invoiceData: any) => {
    if (currentFloat && currentFloat.status === 'OPEN') {
      setInvoiceToAddItem(invoiceData)
      setModalfrequentsaleshow(true)
      setFrequentsaleDetails({})
      myRef2.current.ResetmodalvaluesForAddItems(invoiceData)
    } else {
      showModalcashfloat()
    }
  }
  const {
    isLoading: paymenttypesisloading,
    isSuccess: paymenttypessuccess,
    data: paymenttypesinvoicedata,
    refetch: paymenttypesrefetch,
  } = useSalesInvoicespaymenttypes(
    Number(currentUser?.user_id),
    'PAID',
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    'PAID'
  )

  const { mutateAsync: deleteinvoicesalesmutateAsync } = useDeletesalesinvoices(
    invoicetodelete.invoice_id
  )

  const {
    isLoading: sumprofitorlossloading,
    isSuccess: sumprofitorlosssuccess,
    data: sumprofitorlossdata,
    status: sumprofitorlossstatus,
    isRefetching: sumprofitorlossrefetching,
    refetch: sumprofitorlossrefetch,
  } = useSumprofitorlossusequery(
    Number(currentUser?.user_id),
    statusssumdash,
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    startlimitsumdash,
    database_limitsumdash
  )

  const {
    isLoading: sumexpenseloading,
    isSuccess: sumexpensesuccess,
    data: sumexpensedata,
    status: sumexpensestatus,
    isRefetching: sumexpenserefetching,
    refetch: sumexpenserefetch,
  } = useSumexpenseusequery(
    Number(currentUser?.user_id),
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    startlimitsumdash,
    database_limitsumdash
  )

  const {
    isLoading: sumsalesInvoicesloading,
    isSuccess: sumsalesInvoicessuccess,
    data: sumsalesInvoicesdata,
    status: sumsalesInvoicesstatus,
    isRefetching: sumsalesInvoicerefetching,
    refetch: sumsalesInvoicerefetch,
  } = useSumsalesInvoicesusequery(
    Number(currentUser?.user_id),
    statusssumdash,
    new Date(
      dayjs
        .unix(
          dayjs(
            dayjs().startOf('month').subtract(7, 'days').format('YYYY-MM-DD') + OPENING_TIME
          ).unix()
        )
        .format('YYYY-MM-DD hh:mm')
    ),
    new Date(
      dayjs(dayjs().add(1, 'month').startOf('month').format('YYYY-MM-DD') + OPENING_TIME).format(
        'YYYY-MM-DD hh:mm'
      )
    ),
    startlimitsumdash,
    database_limitsumdash
  )

  const tabledata = useMemo(
    () => salesinvoicedata?.data.salesinvoices,
    [salesinvoicedata?.data.salesinvoices, salesinvoicedsuccess]
  )

  const tabledatalength = useMemo(
    () => salesinvoicedata?.data.datalength,
    [salesinvoicedata?.data.datalength, salesinvoicedsuccess]
  )

  const tablename = 'Sales Summary'

  const filteredsubdata = (rowdata: any): number => {
    return rowdata.values.sales_info.length
  }

  const filteredtablesubData = (rowdata: any): any => {
    return rowdata.values.sales_info.sort((a: any, b: any) => (a.datesold > b.datesold ? -1 : 1))
  }

  const showModal = () => {
    setModalshow(true)
    myRef.current.Resetmodalvalues()
  }

  const handleFrequentSaleClick = (x: any = null) => {
    if (currentFloat && currentFloat.status === 'OPEN') {
      setModalfrequentsaleshow(true)
      x ? setFrequentsaleDetails(x) : setFrequentsaleDetails({})
      myRef2.current.Resetmodalvalues2()
    } else {
      showModalcashfloat()
    }
  }

  useEffect(() => {
    if (!sumsalesInvoicerefetching && sumsalesInvoicessuccess) {
      if (
        dayjs(
          dayjs(
            sumsalesInvoicesdata?.data
              .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
              .map((x: any) => x.date_recordednow)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumsalesInvoicesdatanew(sumsalesInvoicesdata?.data)
      } else {
        if (
          dayjs(
            dayjs(
              sumsalesInvoicesdata?.data
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? -1 : 1))
                .map((x: any) => x.date_recordednow)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
          dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumsalesInvoicesdatanew(sumsalesInvoicesdata?.data)
        } else {
          const currentitemsobj2: any = {
            date_recordednow: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            totals: 0,
          }
          setSumsalesInvoicesdatanew([...sumsalesInvoicesdata?.data, currentitemsobj2])
        }
      }
    }

    if (!sumexpenserefetching && sumexpensesuccess) {
      if (
        dayjs(
          dayjs(
            sumexpensedata?.data
              .sort((a: any, b: any) => (a.date_expense_madenow > b.date_expense_madenow ? -1 : 1))
              .map((x: any) => x.date_expense_madenow)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumexpensedatanew(sumexpensedata?.data)
      } else {
        if (
          dayjs(
            dayjs(
              sumexpensedata?.data
                .sort((a: any, b: any) =>
                  a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                )
                .map((x: any) => x.date_expense_madenow)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
          dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumexpensedatanew(sumexpensedata?.data)
        } else {
          const currentitemsobj2: any = {
            date_expense_madenow: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            totals: 0,
          }
          setSumexpensedatanew([...sumexpensedata?.data, currentitemsobj2])
        }
      }
    }

    if (!sumprofitorlossrefetching && sumprofitorlosssuccess) {
      if (
        dayjs(
          dayjs(
            sumprofitorlossdata?.data
              .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
              .map((x: any) => x.datesoldnow)[0]
          ).format('YYYY-MM-DD')
        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
      ) {
        setSumprofitorlossdatanew(sumprofitorlossdata?.data)
      } else {
        if (
          dayjs(
            dayjs(
              sumprofitorlossdata?.data
                .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                .map((x: any) => x.datesoldnow)[0]
            ).format('YYYY-MM-DD')
          ).unix() === dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix() &&
          dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() <=
          dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix()
        ) {
          setSumprofitorlossdatanew(sumprofitorlossdata?.data)
        } else {
          const currentitemsobj2: any = {
            datesoldnow: dayjs().format('YYYY-MM-DD'),
            date_start: dayjs().format('YYYY-MM-DD'),
            date_end: dayjs().format('YYYY-MM-DD'),
            occurrences: 0,
            hours_selling: 0,
            totals: 0,
          }

          setSumprofitorlossdatanew([...sumprofitorlossdata?.data, currentitemsobj2])
        }
      }
    }
  }, [
    sumexpenserefetching,
    sumprofitorlossrefetching,
    sumsalesInvoicerefetching,
    sumsalesInvoicessuccess,
    sumprofitorlosssuccess,
    sumexpensesuccess,
  ])

  const showModalupdate = (x: any) => {
    setModalshowupdate(true)
    setInvoiceupdate(x)
    myRefupdate.current.Resetmodalupdatevalues()
  }

  const deleteInvoiceSales = async () => {
    setStatedeletinginvoice(true)

    deleteinvoicesalesmutateAsync(invoicetodelete.invoice_id, {
      onSuccess: () => {
        setStatedeletinginvoice(false)
        setModalshowdelete(false)
      },
      onError(error, _variables, _context) {
        console.log(error)
        setStatedeletinginvoice(true)
        setModalshowdelete(false)
      },
    })
  }

  const showModaldelete = (x: any) => {
    setModalshowdelete(true)
    setStatedeletinginvoice(false)
    setInvoicetodelete(x)
  }

  const showModalexpenses = () => {
    setModalshowexpenses(true)
    myRefexpenses.current.Resetmodalexpensesvalues()
  }
  const showCustomerModal = () => {
    setModalCustomershow(true)
  }
  const handlesearchKeyDown = (event: any) => {
    if (event.key === 'Enter') {
      const inputValue = event.target.value
      if (inputValue) {
        setSearch_item(inputValue + '%')
      } else {
        setSearch_item('%')
      }
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('date_recorded')
      setDesorasc('DESC')
      setMovetofirstpage(true)
    }
  }

  const handleinputs = (event: any) => {
    if (myRefsearch.current.value === '' || event.target.value === '') {
      setSearch_item('%')
      setPaginationsize(10)
      setStartlimit(0)
      setItemto_order('date_recorded')
      setDesorasc('DESC')
      setMovetofirstpage(true)
    }
  }

  const handlesearchKeyDown2 = (event: any) => {
    event.preventDefault()

    const inputValue = myRefsearch.current.value || event.target.value

    if (inputValue) {
      setSearch_item(inputValue + '%')
    } else {
      setSearch_item('%')
    }

    setPaginationsize(10)
    setStartlimit(0)
    setItemto_order('date_recorded')
    setDesorasc('DESC')
    setMovetofirstpage(true)
  }

  socket.on('update', (_arg: any) => {
    ; (async () => {
      try {

        await refloadingbar.current?.continuousStart()

        await sumsalesInvoicerefetch()
        await sumprofitorlossrefetch()
        await sumexpenserefetch()
        await salesinvoicerefetch()
        await frequentlysoldrefetch()
        await todaysFloatRefetch()
        await todaysFloatRefetch()
        await paymenttypesrefetch()
      } catch (error) {
        console.log(error)
      } finally {
        await refloadingbar.current?.complete()
      }
    })()
  })

  socket.on('mpesa_balance', (arg: any) => {
    setMpesatransaction(arg)
    setMpesapayload(true)
  })

  useEffect(() => {
    if (mpesatransaction && mpesapayload) {
      setModalshowmpesa(true)
      setMpesapayload(false)
    }
  }, [mpesapayload])

  const columndata1: ReadonlyArray<
    Column<{
      invoice_id: number
      total_amount: number
      amount_tendered: number
      date_recorded: string
      user_id: string
      customer_id: number
      payment_type_id: number
      status: string
      payment_type_name: string
      sales_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Id',
        accessor: 'invoice_id', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          const popover = (
            <Popover>
              <Popover.Header className='fw-bolder text-hover-success fs-6'>
                <strong className='text-primary'>{value}</strong>
                <span className='h-10px border-gray-200 border-start mx-2'></span>
                Invoice Summary
              </Popover.Header>
              <Popover.Body>
                <div className='table-responsive'>
                  <table className='table table-hover table-rounded table-striped border gy-3 gs-3'>
                    <thead>
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th>Product</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array(row.original.sales_info)
                        .flatMap((f: any) => f)
                        .map((x: any, keys: any) => (
                          <tr key={keys + x.product_name}>
                            <td className='text-dark text-nowrap  fw-bolder fs-6' title={x.product_name}>
                              {x.product_name ? truncate(x.product_name, 20) : null}
                            </td>
                            <td className='text-muted text-nowrap fw-bolder fs-6'>{x.quantity}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </Popover.Body>
            </Popover>
          )

          return (
            <div className='d-flex align-items-center'>
              <OverlayTrigger trigger={['hover', 'focus']} placement='right' overlay={popover}>
                <div className='symbol symbol-60px me-5'>
                  <span className='svg-icon svg-icon-primary svg-icon-3x'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M5.857 2h7.88a1.5 1.5 0 01.968.355l4.764 4.029A1.5 1.5 0 0120 7.529v12.554c0 1.79-.02 1.917-1.857 1.917H5.857C4.02 22 4 21.874 4 20.083V3.917C4 2.127 4.02 2 5.857 2z'
                          opacity='1'
                        ></path>
                        <rect width='9' height='2' x='6' y='11' fill='#fff' rx='1'></rect>
                        <rect width='5' height='2' x='6' y='15' fill='#fff' rx='1'></rect>
                      </g>
                    </svg>
                  </span>
                </div>
              </OverlayTrigger>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark fw-bolder fs-6'>
                  {value}

                  <span className='h-10px border-gray-200 border-start mx-2'></span>
                  <span className='text-success fw-bolder text-hover-success fs-6'>
                    {Array(row.original.sales_info)
                      .flatMap((f: any) => f)
                      .map((c: any) => c.quantity)
                      .reduce((a: number, b: number) => a + b, 0)}
                  </span>
                </span>

                <span className='text-nowrap  fw-bold text-muted d-block fs-7 mt-1' title={
                  Array(row.original.sales_info)
                  .flatMap((f: any) => f)
                  .map((c: any) => c.product_name)[0]
                }>
                  {truncate(
                    Array(row.original.sales_info)
                      .flatMap((f: any) => f)
                      .map((c: any) => c.product_name)[0],
                    20
                  )}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Total',
        accessor: 'total_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              <span
                className={`${row.original.payment_type_name === 'MPESA'
                  ? 'badge badge-light-success'
                  : row.original.payment_type_name === 'CHEQUE'
                    ? 'badge badge-light-warning'
                    : row.original.payment_type_name === 'MPESACASH'
                      ? 'badge badge-light-info'
                      : 'badge badge-light-primary'
                  }`}
              >
                {row.original.payment_type_name}
              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'sales_info',
        accessor: 'sales_info',
      },
      {
        Header: 'Date',
        accessor: 'date_recorded',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'Status',
        accessor: 'status',

        Cell: ({ cell: { value }, row }) =>
          value === 'PAID' ? (
            <>
              <span className=' text-nowrap'>
                <span className='badge badge-light-success'>
                  <span className=' text-nowrap fs-7'>{value}</span>
                </span>{' '}
                {isUserAdmin() && (
                  <>
                    {isNegative(
                      Array(row.original.sales_info)
                        .flatMap((f: any) => f)
                        .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                        .reduce((a: number, b: number) => a + b, 0)
                    ) ? (
                      <sup className='text-danger'>
                        -
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    ) : (
                      <sup className='text-primary'>
                        +
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    )}
                  </>
                )}
              </span>
            </>
          ) : (
            <>
              <span className=' text-nowrap'>
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>{value}</span>
                </span>{' '}
                {isUserAdmin() && (
                  <>
                    {isNegative(
                      Array(row.original.sales_info)
                        .flatMap((f: any) => f)
                        .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                        .reduce((a: number, b: number) => a + b, 0)
                    ) ? (
                      <sup className='text-muted'>
                        -
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    ) : (
                      <sup className='text-muted'>
                        +
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    )}
                  </>
                )}
              </span>
            </>
          ),
      },

      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              {/* Show edit button only if status is not PAID OR user is admin */}
              {(row.original.status !== 'PAID' || isUserAdmin()) && (
                <>
                  <a
                    className="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                    onClick={() => handleAddItemToInvoice(row.original)}
                    title="Add item"
                  >
                    <span className="svg-icon svg-icon-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 6V18M6 12H18"
                          stroke="#009ef7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </a>




                  <a
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    onClick={() => showModalupdate(row.original)}
                  >
                    <span className='svg-icon svg-icon-3'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                          fill='black'
                        ></path>
                        <path
                          d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                          fill='black'
                        ></path>
                      </svg>
                    </span>
                  </a>
                </>
              )}
              {/* Conditionally render delete button only for admins */}
              {isUserAdmin() && (
                <a
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  onClick={() => showModaldelete(row.original)}
                >
                  {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                  <span className='svg-icon svg-icon-3'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width={24}
                      height={24}
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                        fill='#f1416c'
                      />
                    </svg>
                  </span>
                  {/*end::Svg Icon*/}
                </a>
              )}
            </div>
          )
        },
      }
    ]
  const columndata2: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      products_unit: number
      discount_percentage: number
      product_unit_id: number
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
      unit_name: string
    }>
  > = [
      {
        Header: 'S.id',
        accessor: 'sales_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
          </>
        ),
      },
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
              {truncate(row.original.product_name, 20)}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>{value}</span>
          </>
        ),
      },

      {
        Header: 'Quantity',
        accessor: 'quantity',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {row.original.unit_name}
            </span>
          </>
        ),
      },

      {
        Header: 'Price',
        accessor: 'unit_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {row.original.discount_percentage}% OFF
            </span>
          </>
        ),
      },
      {
        Header: 'Total',
        accessor: 'sub_total',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
    ]

  // less than 420

  const columndata3: ReadonlyArray<
    Column<{
      invoice_id: number
      total_amount: number
      amount_tendered: number
      date_recorded: string
      user_id: string
      customer_id: number
      payment_type_id: number
      status: string
      payment_type_name: string
      sales_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Id',
        accessor: 'invoice_id', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark fw-bolder fs-6'>{value}</span>

                <span className='text-nowrap  fw-bold text-muted d-block fs-7 mt-1'>
                  <span
                    className={`${row.original.payment_type_name === 'MPESA'
                      ? 'badge badge-light-success'
                      : row.original.payment_type_name === 'CHEQUE'
                        ? 'badge badge-light-warning'
                        : row.original.payment_type_name === 'MPESACASH'
                          ? 'badge badge-light-info'
                          : 'badge badge-light-primary'
                      }`}
                  >
                    {row.original.payment_type_name}
                  </span>{' '}
                  <span>
                    {row.original.status === 'PAID' ? (
                      <>
                        <span className=' text-nowrap'>
                          <span className='badge badge-light-success'>
                            <span className=' text-nowrap fs-7'>{row.original.status}</span>
                          </span>

                        </span>
                      </>
                    ) : (
                      <>
                        <span className=' text-nowrap'>
                          <span className='badge badge-light-danger'>
                            <span className='text-nowrap fs-7'>{row.original.status}</span>
                          </span>
                        </span>
                      </>
                    )}
                  </span>
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'sales_info',
        accessor: 'sales_info',
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              {/* Show edit button only if status is not PAID OR user is admin */}
              {(row.original.status !== 'PAID' || isUserAdmin()) && (
                <>
                  <a
                    className="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                    onClick={() => handleAddItemToInvoice(row.original)}
                    title="Add item"
                  >
                    <span className="svg-icon svg-icon-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 6V18M6 12H18"
                          stroke="#009ef7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </a>




                  <a
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    onClick={() => showModalupdate(row.original)}
                  >
                    <span className='svg-icon svg-icon-3'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                          fill='black'
                        ></path>
                        <path
                          d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                          fill='black'
                        ></path>
                      </svg>
                    </span>
                  </a>
                </>
              )}
              {/* Conditionally render delete button only for admins */}
              {isUserAdmin() && (
                <a
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  onClick={() => showModaldelete(row.original)}
                >
                  {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                  <span className='svg-icon svg-icon-3'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width={24}
                      height={24}
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                        fill='#f1416c'
                      />
                    </svg>
                  </span>
                  {/*end::Svg Icon*/}
                </a>
              )}
            </div>
          )
        },
      }
    ]

  const columndata4: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      products_unit: number
      discount_percentage: number
      product_unit_id: number
      unit_name: string
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
    }>
  > = [
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
              {truncate(row.original.product_name, 20)}

              <span className='h-10px border-gray-200 border-start mx-2'></span>
              <span>{row.original.quantity}</span>
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {dayjs(row.original.datesold).calendar()}
              <span className='h-10px border-gray-200 border-start mx-2'></span>
              {addCommas(row.original.sub_total.toFixed(2))} {CURRENCY_APP}{' '}
            </span>
          </>
        ),
      },
    ]

  //less than 420

  //less than 730 but more than 420
  const columndata5: ReadonlyArray<
    Column<{
      invoice_id: number
      total_amount: number
      amount_tendered: number
      date_recorded: string
      user_id: string
      customer_id: number
      payment_type_id: number
      status: string
      payment_type_name: string
      sales_info: Array<number | string>
    }>
  > = [
      {
        Header: () => null,
        id: 'expander',

        Cell: ({ row }: any) => {
          return (
            <span {...row.getToggleRowExpandedProps()}>
              {row.isExpanded ? (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M17.293 8.293a1 1 0 111.414 1.414l-6 6a1 1 0 01-1.383.03l-6-5.5a1 1 0 111.352-1.474l5.294 4.853 5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              ) : (
                <>
                  <span className='svg-icon svg-icon-primary'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      xmlnsXlink='http://www.w3.org/1999/xlink'
                      width='24'
                      height='24'
                      viewBox='0 0 24 24'
                    >
                      <g fill='none' fillRule='evenodd'>
                        <path d='M0 0L24 0 24 24 0 24z'></path>
                        <path
                          fill='#009ef7'
                          fillRule='nonzero'
                          d='M8.293 6.707a1 1 0 111.414-1.414l6 6a1 1 0 01.03 1.383l-5.5 6a1 1 0 11-1.474-1.352l4.853-5.294-5.323-5.323z'
                        ></path>
                      </g>
                    </svg>
                  </span>
                </>
              )}
            </span>
          )
        },
      },
      {
        Header: 'Id',
        accessor: 'invoice_id', // accessor is the "key" in the data

        Cell: ({ cell: { value }, row }) => {
          const popover = (
            <Popover>
              <Popover.Header className='fw-bolder text-hover-success fs-6'>
                <strong className='text-primary'>{value}</strong>
                <span className='h-10px border-gray-200 border-start mx-2'></span>
                Invoice Summary
              </Popover.Header>
              <Popover.Body>
                <div className='table-responsive'>
                  <table className='table table-hover table-rounded table-striped border gy-3 gs-3'>
                    <thead>
                      <tr className='fw-bold fs-6 text-gray-800 border-bottom-2 border-gray-200'>
                        <th>Product</th>
                        <th>Quantity</th>
                      </tr>
                    </thead>
                    <tbody>
                      {Array(row.original.sales_info)
                        .flatMap((f: any) => f)
                        .map((x: any, keys: any) => (
                          <tr key={keys + x.product_name}>
                            <td className='text-dark text-nowrap  fw-bolder fs-6' title={x.product_name}>
                              {x.product_name ? truncate(x.product_name, 20) : null}
                            </td>
                            <td className='text-muted text-nowrap fw-bolder fs-6'>{x.quantity}</td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                </div>
              </Popover.Body>
            </Popover>
          )

          return (
            <div className='d-flex align-items-center'>
              <div className='d-flex justify-content-start flex-column'>
                <span className='text-dark fw-bolder fs-6'>
                  {value}

                  <span className='h-10px border-gray-200 border-start mx-2'></span>
                  <span className='text-success fw-bolder text-hover-success fs-6'>
                    {Array(row.original.sales_info)
                      .flatMap((f: any) => f)
                      .map((c: any) => c.quantity)
                      .reduce((a: number, b: number) => a + b, 0)}
                  </span>
                </span>

                <span className='text-nowrap  fw-bold text-muted d-block fs-7 mt-1' title={Array(row.original.sales_info)
                      .flatMap((f: any) => f)
                      .map((c: any) => c.product_name)[0]}>
                  {truncate(
                    Array(row.original.sales_info)
                      .flatMap((f: any) => f)
                      .map((c: any) => c.product_name)[0],
                    20
                  )}
                </span>
              </div>
            </div>
          )
        },
      },
      {
        Header: 'Total',
        accessor: 'total_amount',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              <span
                className={`${row.original.payment_type_name === 'MPESA'
                  ? 'badge badge-light-success'
                  : row.original.payment_type_name === 'CHEQUE'
                    ? 'badge badge-light-warning'
                    : row.original.payment_type_name === 'MPESACASH'
                      ? 'badge badge-light-info'
                      : 'badge badge-light-primary'
                  }`}
              >
                {row.original.payment_type_name}
              </span>
            </span>
          </>
        ),
      },
      {
        Header: 'sales_info',
        accessor: 'sales_info',
      },
      {
        Header: 'Date',
        accessor: 'date_recorded',

        Cell: ({ cell: { value } }) => (
          <>
            <span className='text-dark text-nowrap fw-bolder d-block mb-1 fs-6'>
              {dayjs(value).format('LL')}
            </span>
            <span className='text-muted  text-nowrap fw-bold text-muted d-block fs-7'>
              {dayjs(value).format('dddd')}, {dayjs(value).format('LTS')}
            </span>
          </>
        ),
      },
      {
        Header: 'Status',
        accessor: 'status',

        Cell: ({ cell: { value }, row }) =>
          value === 'PAID' ? (
            <>
              <span className=' text-nowrap'>
                <span className='badge badge-light-success'>
                  <span className=' text-nowrap fs-7'>{value}</span>
                </span>{' '}
                {isUserAdmin() && (
                  <>
                    {isNegative(
                      Array(row.original.sales_info)
                        .flatMap((f: any) => f)
                        .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                        .reduce((a: number, b: number) => a + b, 0)
                    ) ? (
                      <sup className='text-danger'>
                        -
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    ) : (
                      <sup className='text-primary'>
                        +
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    )}
                  </>
                )}
              </span>
            </>
          ) : (
            <>
              <span className=' text-nowrap'>
                <span className='badge badge-light-danger'>
                  <span className='text-nowrap fs-7'>{value}</span>
                </span>{' '}
                {isUserAdmin() && (
                  <>
                    {isNegative(
                      Array(row.original.sales_info)
                        .flatMap((f: any) => f)
                        .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                        .reduce((a: number, b: number) => a + b, 0)
                    ) ? (
                      <sup className='text-muted'>
                        -
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    ) : (
                      <sup className='text-muted'>
                        +
                        {addCommas(
                          Array(row.original.sales_info)
                            .flatMap((f: any) => f)
                            .map((c: any) => c.quantity * c.unit_price - c.quantity * c.unit_buying_price)
                            .reduce((a: number, b: number) => a + b, 0)
                            .toFixed(2)
                        )}
                      </sup>
                    )}
                  </>
                )}
              </span>
            </>
          ),
      },
      {
        Header: () => null,
        id: 'expander2',
        Cell: ({ row }: any) => {
          return (
            <div className='d-flex justify-content-end flex-shrink-0'>
              {/* Show edit button only if status is not PAID OR user is admin */}
              {(row.original.status !== 'PAID' || isUserAdmin()) && (
                <>
                  <a
                    className="btn btn-icon btn-bg-light btn-active-color-success btn-sm me-1"
                    onClick={() => handleAddItemToInvoice(row.original)}
                    title="Add item"
                  >
                    <span className="svg-icon svg-icon-3">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="22"
                        height="22"
                        viewBox="0 0 24 24"
                        fill="none"
                      >
                        <path
                          d="M12 6V18M6 12H18"
                          stroke="#009ef7"
                          strokeWidth="2"
                          strokeLinecap="round"
                          strokeLinejoin="round"
                        />
                      </svg>
                    </span>
                  </a>




                  <a
                    className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm me-1'
                    onClick={() => showModalupdate(row.original)}
                  >
                    <span className='svg-icon svg-icon-3'>
                      <svg
                        xmlns='http://www.w3.org/2000/svg'
                        width='24'
                        height='24'
                        viewBox='0 0 24 24'
                        fill='none'
                      >
                        <path
                          opacity='0.3'
                          d='M21.4 8.35303L19.241 10.511L13.485 4.755L15.643 2.59595C16.0248 2.21423 16.5426 1.99988 17.0825 1.99988C17.6224 1.99988 18.1402 2.21423 18.522 2.59595L21.4 5.474C21.7817 5.85581 21.9962 6.37355 21.9962 6.91345C21.9962 7.45335 21.7817 7.97122 21.4 8.35303ZM3.68699 21.932L9.88699 19.865L4.13099 14.109L2.06399 20.309C1.98815 20.5354 1.97703 20.7787 2.03189 21.0111C2.08674 21.2436 2.2054 21.4561 2.37449 21.6248C2.54359 21.7934 2.75641 21.9115 2.989 21.9658C3.22158 22.0201 3.4647 22.0084 3.69099 21.932H3.68699Z'
                          fill='black'
                        ></path>
                        <path
                          d='M5.574 21.3L3.692 21.928C3.46591 22.0032 3.22334 22.0141 2.99144 21.9594C2.75954 21.9046 2.54744 21.7864 2.3789 21.6179C2.21036 21.4495 2.09202 21.2375 2.03711 21.0056C1.9822 20.7737 1.99289 20.5312 2.06799 20.3051L2.696 18.422L5.574 21.3ZM4.13499 14.105L9.891 19.861L19.245 10.507L13.489 4.75098L4.13499 14.105Z'
                          fill='black'
                        ></path>
                      </svg>
                    </span>
                  </a>
                </>
              )}
              {/* Conditionally render delete button only for admins */}
              {isUserAdmin() && (
                <a
                  className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                  onClick={() => showModaldelete(row.original)}
                >
                  {/*begin::Svg Icon | path: icons/duotune/general/gen027.svg*/}
                  <span className='svg-icon svg-icon-3'>
                    <svg
                      xmlns='http://www.w3.org/2000/svg'
                      width={24}
                      height={24}
                      viewBox='0 0 24 24'
                      fill='none'
                    >
                      <path
                        d='M5 9C5 8.44772 5.44772 8 6 8H18C18.5523 8 19 8.44772 19 9V18C19 19.6569 17.6569 21 16 21H8C6.34315 21 5 19.6569 5 18V9Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M5 5C5 4.44772 5.44772 4 6 4H18C18.5523 4 19 4.44772 19 5V5C19 5.55228 18.5523 6 18 6H6C5.44772 6 5 5.55228 5 5V5Z'
                        fill='#f1416c'
                      />
                      <path
                        opacity='0.5'
                        d='M9 4C9 3.44772 9.44772 3 10 3H14C14.5523 3 15 3.44772 15 4V4H9V4Z'
                        fill='#f1416c'
                      />
                    </svg>
                  </span>
                  {/*end::Svg Icon*/}
                </a>
              )}
            </div>
          )
        },
      }
    ]
  const columndata6: ReadonlyArray<
    Column<{
      sales_id: number
      quantity: number
      unit_price: number
      sub_total: number
      product_id: number
      products_unit: number
      discount_percentage: number
      product_unit_id: number
      user_id: number
      sales_invoice_id: string
      datesold: string
      sales_status: string
      product_name: string
      unit_name: string
    }>
  > = [
      {
        Header: 'Product',
        accessor: 'product_id',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-primary text-nowrap  fw-bolder d-block mb-1 fs-6' title={row.original.product_name}>
              {truncate(row.original.product_name, 20)}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Product Id {value}
            </span>
          </>
        ),
      },

      {
        Header: 'Quantity',
        accessor: 'quantity',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>{value}</span>
            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              {row.original.unit_name}
            </span>
          </>
        ),
      },

      {
        Header: 'Price',
        accessor: 'unit_price',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-dark text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>

            <span className='text-muted  text-nowrap  fw-bold text-muted d-block fs-7'>
              Discount: {row.original.discount_percentage}%
            </span>
          </>
        ),
      },
      {
        Header: 'Total',
        accessor: 'sub_total',

        Cell: ({ cell: { value }, row }) => (
          <>
            <span className='text-success text-nowrap  fw-bolder d-block mb-1 fs-6'>
              {addCommas(value.toFixed(2))} {CURRENCY_APP}
            </span>
          </>
        ),
      },
    ]

  //less than 730 but more than 420

  //shortcuts
  // Using TypeScript to provide type checking for the productid and barcode parameters
  const handleSequence = async ({ productid, barcode }: { productid: string; barcode: string }) => {
    // Reset the modal values and exit if modalfrequentsaleshow is true and productid is "++"
    if (modalfrequentsaleshow && productid === '++') {
      myRef2.current.Resetmodalvalues4()
      return
    }

    // Remove leading zeros from the productid if it exists
    const sequenceProductId = productid ? Number(productid.replace(/^00/, '')) : null

    // Get the filtered data based on the sequenceProductId and barcode
    const filteredData = await getFilteredData(sequenceProductId, barcode)
    if (!filteredData) {
      return // Exit if there is no filtered data
    }

    // Show the frequent sale modal if modalfrequentsaleshow is false
    if (!modalfrequentsaleshow) {
      handleFrequentSaleClick(filteredData)
    } else if (productid !== '++') {
      // If modalfrequentsaleshow is true, the productid is not "++", and filtered data exists:
      // Reset modal values, set the frequent sale details, and flag a double entry
      myRef2.current.Resetmodalvalues3()
      setFrequentsaleDetails(filteredData)
      setFrequentsaledoubleentry(true)
    }
  }

  const getFilteredData = async (sequenceProductId: number | null, barcode: string) => {
    if (sequenceProductId === null && (barcode === null || barcode === '')) {
      return null
    }

    const filteredData = allproductsdetails?.find(
      (f: any) =>
        (sequenceProductId !== null && f.product_id === sequenceProductId) ||
        (barcode !== null && barcode !== '' && f.barcode === barcode)
    )

    if (filteredData) {
      filteredData.quantity = 1
    }

    return filteredData
  }

  const keySequences = [
    ...(allproductsdetails
      ?.filter((x: any) => x.units_in_stock > 0)
      .map((x: any) => ({
        productid: '00' + x.product_id,
        barcode: x.barcode || '',
      })) || []),
    { productid: '++', barcode: '++' },
  ]

  useKeySequence(keySequences || [], handleSequence)

  //shortcut

  useEffect(() => {
    if (allproductsdata?.data.allproducts.length > 0) {
      setAllproductsDetails(allproductsdata?.data.allproducts)
    }
  }, [allproductssuccess])

  useEffect(() => {
    if (sumexpensesuccess && sumprofitorlosssuccess && sumsalesInvoicessuccess) {
      setStatusnow(true)
    } else {
      setStatusnow(false)
    }
  }, [sumexpensesuccess, sumprofitorlosssuccess, sumsalesInvoicessuccess])

  useEffect(() => {
    if (
      statusnow &&
      !sumexpenserefetching &&
      !sumprofitorlossrefetching &&
      !sumsalesInvoicerefetching
    ) {
      setStatusnow2(true)
    } else {
      setStatusnow2(false)
    }
  }, [sumexpenserefetching, sumprofitorlossrefetching, sumsalesInvoicerefetching])

  return (
    <>
      <LoadingBar color='#009ef7' ref={refloadingbar} />
      <PageTitle breadcrumbs={usersBreadcrumbs}>Sales Invoice</PageTitle>
      {/* begin::Row */}
      {/* begin::Row */}
      {showDashboard && (
        <div className='row g-5 g-xl-8'>
          {/* begin::Col */}

          <div className={isUserAdmin() ? 'col-xl-4' : 'col-xl-6'}>
            <ItemsSummary
              className='card-xl-stretch mb-xl-8'
              chartColor='primary'
              chartHeight='120px'
              cardName='Sales'
              chartName='Sales'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...sumsalesInvoicesdatanew.map((x: any) => x.totals)))}
              chartCategories={sumsalesInvoicesdatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => dayjs(x.date_recordednow).format('LL'))}
              chartData={sumsalesInvoicesdatanew
                .sort((a: any, b: any) => (a.date_recordednow > b.date_recordednow ? 1 : -1))
                .map((x: any) => x.totals)}
              values={
                <>
                  <div className='fs-2 fw-bolder d-block '>
                    <CountUp
                      className='text-primary'
                      end={
                        sumsalesInvoicesdatanew
                          .sort((a: any, b: any) =>
                            a.date_recordednow > b.date_recordednow ? -1 : 1
                          )
                          .map((x: any) => x.totals)[0]
                      }
                      duration={2}
                      decimals={2}
                      separator=','
                    />{' '}
                    <sup className='fs-6 text-primary'>{CURRENCY_APP}</sup>
                  </div>
                </>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {sumsalesInvoicesdatanew
                          .sort((a: any, b: any) =>
                            a.date_recordednow > b.date_recordednow ? -1 : 1
                          )
                          .map((x: any) => x.date_recordednow)[1] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-primary'>
                                {dayjs(
                                  sumsalesInvoicesdatanew
                                    .sort((a: any, b: any) =>
                                      a.date_recordednow > b.date_recordednow ? -1 : 1
                                    )
                                    .map((x: any) => x.date_recordednow)[1]
                                ).calendar(null, {
                                  sameDay: '[Today]',
                                  nextDay: '[Tomorrow]',
                                  nextWeek: 'dddd',
                                  lastDay: '[Yesterday]',
                                  lastWeek: 'dddd',
                                  sameElse: 'DD/MM/YYYY',
                                })}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={
                                  sumsalesInvoicesdatanew
                                    .sort((a: any, b: any) =>
                                      a.date_recordednow > b.date_recordednow ? -1 : 1
                                    )
                                    .map((x: any) => x.totals)[1]
                                }
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {sumsalesInvoicesdatanew
                          .sort((a: any, b: any) =>
                            a.date_recordednow > b.date_recordednow ? -1 : 1
                          )
                          .map((x: any) => x.date_recordednow)[2] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-primary'>
                                {dayjs(
                                  sumsalesInvoicesdatanew
                                    .sort((a: any, b: any) =>
                                      a.date_recordednow > b.date_recordednow ? -1 : 1
                                    )
                                    .map((x: any) => x.date_recordednow)[2]
                                ).calendar(null, {
                                  sameDay: '[Today]',
                                  nextDay: '[Tomorrow]',
                                  nextWeek: 'dddd',
                                  lastDay: '[Yesterday]',
                                  lastWeek: 'dddd',
                                  sameElse: 'DD/MM/YYYY',
                                })}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={
                                  sumsalesInvoicesdatanew
                                    .sort((a: any, b: any) =>
                                      a.date_recordednow > b.date_recordednow ? -1 : 1
                                    )
                                    .map((x: any) => x.totals)[2]
                                }
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}
          <div className={isUserAdmin() ? 'col-xl-4' : 'col-xl-6'}>
            <ItemsSummary
              className={isUserAdmin() ? 'card-xl-stretch mb-xl-8' : 'card-xl-stretch mb-5 mb-xl-8'}
              chartColor='danger'
              chartHeight='120px'
              cardName='Expenses'
              chartName='Expenses'
              statusnow={statusnow}
              statusnow2={statusnow2}
              yaxisHeight={Math.abs(Math.max(...sumexpensedatanew.map((x: any) => x.totals)))}
              chartCategories={sumexpensedatanew
                .sort((a: any, b: any) => (a.date_expense_madenow > b.date_expense_madenow ? 1 : -1))
                .map((x: any) => dayjs(x.date_expense_madenow).format('LL'))}
              chartData={sumexpensedatanew
                .sort((a: any, b: any) => (a.date_expense_madenow > b.date_expense_madenow ? 1 : -1))
                .map((x: any) => x.totals)}
              values={
                <div className='fs-2 fw-bolder'>
                  <CountUp
                    className='text-danger'
                    end={
                      sumexpensedatanew
                        .sort((a: any, b: any) =>
                          a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                        )
                        .map((x: any) => x.totals)[0]
                    }
                    duration={2}
                    decimals={2}
                    separator=','
                  />{' '}
                  <sup className='text-danger fs-6'>{CURRENCY_APP}</sup>
                </div>
              }
              values2={
                <>
                  <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                    <table>
                      <tbody>
                        {sumexpensedatanew
                          .sort((a: any, b: any) =>
                            a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                          )
                          .map((x: any) => x.date_expense_madenow)[1] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-danger'>
                                {dayjs(
                                  sumexpensedatanew
                                    .sort((a: any, b: any) =>
                                      a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                                    )
                                    .map((x: any) => x.date_expense_madenow)[1]
                                ).calendar(null, {
                                  sameDay: '[Today]',
                                  nextDay: '[Tomorrow]',
                                  nextWeek: 'dddd',
                                  lastDay: '[Yesterday]',
                                  lastWeek: 'dddd',
                                  sameElse: 'DD/MM/YYYY',
                                })}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={
                                  sumexpensedatanew
                                    .sort((a: any, b: any) =>
                                      a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                                    )
                                    .map((x: any) => x.totals)[1]
                                }
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}

                        {sumexpensedatanew
                          .sort((a: any, b: any) =>
                            a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                          )
                          .map((x: any) => x.date_expense_madenow)[2] ? (
                          <tr>
                            <td>
                              <span className='badge badge-light-danger'>
                                {dayjs(
                                  sumexpensedatanew
                                    .sort((a: any, b: any) =>
                                      a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                                    )
                                    .map((x: any) => x.date_expense_madenow)[2]
                                ).calendar(null, {
                                  sameDay: '[Today]',
                                  nextDay: '[Tomorrow]',
                                  nextWeek: 'dddd',
                                  lastDay: '[Yesterday]',
                                  lastWeek: 'dddd',
                                  sameElse: 'DD/MM/YYYY',
                                })}
                              </span>
                            </td>
                            <td>
                              <span className='h-20px border-gray-200 border-start mx-2'></span>
                              <CountUp
                                className='text-bold text-muted'
                                end={
                                  sumexpensedatanew
                                    .sort((a: any, b: any) =>
                                      a.date_expense_madenow > b.date_expense_madenow ? -1 : 1
                                    )
                                    .map((x: any) => x.totals)[2]
                                }
                                duration={2}
                                decimals={2}
                                separator=','
                              />{' '}
                              <sup className='text-muted'>{CURRENCY_APP}</sup>
                            </td>
                          </tr>
                        ) : (
                          <></>
                        )}
                      </tbody>
                    </table>
                  </span>
                </>
              }
            />
          </div>
          {/* end::Col */}

          {/* begin::Col */}

          {isUserAdmin() && (

            <div className='col-xl-4'>
              <ItemsSummary
                className='card-xl-stretch mb-5 mb-xl-8'
                chartColor={`${isNegative(
                  sumprofitorlossdatanew
                    .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                    .map((x: any) => x.totals)[0]
                )
                  ? 'danger'
                  : 'success'
                  }`}
                chartHeight='120px'
                statusnow={statusnow}
                statusnow2={statusnow2}
                cardName={`${isNegative(
                  sumprofitorlossdatanew
                    .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                    .map((x: any) => x.totals)[0]
                )
                  ? 'Loss'
                  : 'Profit'
                  }`}
                chartName={`${isNegative(
                  sumprofitorlossdatanew
                    .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                    .map((x: any) => x.totals)[0]
                )
                  ? 'Loss'
                  : 'Profit'
                  }`}
                yaxisHeight={
                  Math.abs(
                    Number(Math.max(...sumprofitorlossdatanew.map((x: any) => x.totals)).toFixed(0))
                  ) +
                  Math.abs(
                    Number(Math.min(...sumprofitorlossdatanew.map((x: any) => x.totals)).toFixed(0))
                  )
                }
                chartCategories={sumprofitorlossdatanew
                  .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
                  .map((x: any) => dayjs(x.datesoldnow).format('LL'))}
                chartData={sumprofitorlossdatanew
                  .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? 1 : -1))
                  .map((x: any) => Number(x.totals.toFixed(2)))}
                values={
                  <>
                    <div className='fs-2 fw-bolder'>
                      <CountUp
                        className={`${isNegative(
                          sumprofitorlossdatanew
                            .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                            .map((x: any) => x.totals)[0]
                        )
                          ? 'text-danger'
                          : 'text-success'
                          }`}
                        end={
                          sumprofitorlossdatanew
                            .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                            .map((x: any) => x.totals)[0]
                        }
                        duration={2}
                        decimals={2}
                        separator=','
                      />{' '}
                      <sup
                        className={`${isNegative(
                          sumprofitorlossdatanew
                            .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                            .map((x: any) => x.totals)[0]
                        )
                          ? 'fs-6 text-danger'
                          : 'fs-6 text-success'
                          }`}
                      >
                        {CURRENCY_APP}
                      </sup>
                    </div>
                  </>
                }
                values2={
                  <>
                    <span className='fw-bold d-block fs-7 mt-2 text-muted'>
                      <table>
                        <tbody>
                          {sumprofitorlossdatanew
                            .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                            .map((x: any) => x.totals)[1] ? (
                            <tr>
                              <td>
                                <span
                                  className={`${isNegative(
                                    sumprofitorlossdatanew
                                      .sort((a: any, b: any) =>
                                        a.datesoldnow > b.datesoldnow ? -1 : 1
                                      )
                                      .map((x: any) => x.totals)[1]
                                  )
                                    ? 'badge badge-light-danger'
                                    : 'badge badge-light-success'
                                    }`}
                                >
                                  {dayjs(
                                    sumprofitorlossdatanew
                                      .sort((a: any, b: any) =>
                                        a.datesoldnow > b.datesoldnow ? -1 : 1
                                      )
                                      .map((x: any) => x.datesoldnow)[1]
                                  ).calendar(null, {
                                    sameDay: '[Today]',
                                    nextDay: '[Tomorrow]',
                                    nextWeek: 'dddd',
                                    lastDay: '[Yesterday]',
                                    lastWeek: 'dddd',
                                    sameElse: 'DD/MM/YYYY',
                                  })}
                                </span>
                              </td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <CountUp
                                  className='text-bold text-muted'
                                  end={
                                    sumprofitorlossdatanew
                                      .sort((a: any, b: any) =>
                                        a.datesoldnow > b.datesoldnow ? -1 : 1
                                      )
                                      .map((x: any) => x.totals)[1]
                                  }
                                  duration={2}
                                  decimals={2}
                                  separator=','
                                />{' '}
                                <sup className='text-muted'>{CURRENCY_APP}</sup>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}

                          {sumprofitorlossdatanew
                            .sort((a: any, b: any) => (a.datesoldnow > b.datesoldnow ? -1 : 1))
                            .map((x: any) => x.totals)[2] ? (
                            <tr>
                              <td>
                                <span
                                  className={`${isNegative(
                                    sumprofitorlossdatanew
                                      .sort((a: any, b: any) =>
                                        a.datesoldnow > b.datesoldnow ? -1 : 1
                                      )
                                      .map((x: any) => x.totals)[2]
                                  )
                                    ? 'badge badge-light-danger'
                                    : 'badge badge-light-success'
                                    }`}
                                >
                                  {dayjs(
                                    sumprofitorlossdatanew
                                      .sort((a: any, b: any) =>
                                        a.datesoldnow > b.datesoldnow ? -1 : 1
                                      )
                                      .map((x: any) => x.datesoldnow)[2]
                                  ).calendar(null, {
                                    sameDay: '[Today]',
                                    nextDay: '[Tomorrow]',
                                    nextWeek: 'dddd',
                                    lastDay: '[Yesterday]',
                                    lastWeek: 'dddd',
                                    sameElse: 'DD/MM/YYYY',
                                  })}
                                </span>
                              </td>
                              <td>
                                <span className='h-20px border-gray-200 border-start mx-2'></span>
                                <CountUp
                                  className='text-bold text-muted'
                                  end={
                                    sumprofitorlossdatanew
                                      .sort((a: any, b: any) =>
                                        a.datesoldnow > b.datesoldnow ? -1 : 1
                                      )
                                      .map((x: any) => x.totals)[2]
                                  }
                                  duration={2}
                                  decimals={2}
                                  separator=','
                                />{' '}
                                <sup className='text-muted'>{CURRENCY_APP}</sup>
                              </td>
                            </tr>
                          ) : (
                            <></>
                          )}
                        </tbody>
                      </table>
                    </span>
                  </>
                }
              />
            </div>

          )}

          {/* end::Col */}
        </div>)}
      {/* end::Row */}
      <div className='row g-5 gx-xxl-8'>
        <div className='col-xxl-4'>
          <KTCard>
            <KTCardBody className='py-4'>
              <div className='row mt-4'>
                <div className='col-sm-12 col-md-10 d-flex align-items-center justify-content-center justify-content-md-start'>
                  <div className='mb-2'>
                    <h3 className='fw-bolder my-2'>Add Sales Invoice</h3>
                  </div>
                </div>
                <div className='col-sm-12 col-md-2 d-flex align-items-center justify-content-center justify-content-md-end'></div>
              </div>

              <div className='row'>
                <div className='col-sm-12 col-md-5 col-xxl-12 d-flex align-items-center justify-content-center justify-content-md-start'></div>


                <div className='col-sm-12 col-md-7 col-xxl-12 d-flex align-items-center justify-content-center justify-content-md-end'>
                  <div className='mb-2'>
                    {/* begin::Search */}
                    <div className='col-sm-12 col-md-12  d-flex align-items-center justify-content-center justify-content-md-end'>
                      <div
                        className='mb-2'
                        style={{ display: 'inline-grid', gridTemplateColumns: '1fr 1fr 1fr 1fr' }}
                      >
                        {/* Cash Float button */}
                        <a
                          className='btn btn-info btn-sm me-2 mb-2 text-nowrap'
                          onClick={showModalcashfloat}
                          title={onlyWidth >= 1400 || onlyWidth <= 576 ? 'Add Cash Float' : ''}
                        >
                          <KTSVG
                            path='/media/icons/duotune/finance/fin003.svg'
                            className='svg-icon-1'
                          />
                          {onlyWidth >= 1400 || onlyWidth <= 576 ? '+' : 'Add Cash Float'}
                        </a>
                        <a
                          className='btn btn-success btn-sm mb-2 me-2 text-nowrap'
                          href='#'
                          onClick={(e: React.MouseEvent<HTMLAnchorElement>) => {
                            e.preventDefault()
                            showCustomerModal()
                          }}
                          title={onlyWidth >= 1400 || onlyWidth <= 576 ? 'Add Customer' : ''}
                        >
                          <KTSVG path='/media/icons/duotune/communication/com006.svg' className='svg-icon-1' />
                          {onlyWidth >= 1400 || onlyWidth <= 576 ? '+' : 'Add Customer'}
                        </a>

                        {/* Add Expense button */}
                        <a
                          className='btn btn-danger btn-sm me-2 mb-2 text-nowrap'
                          onClick={showModalexpenses}
                          title={onlyWidth >= 1400 || onlyWidth <= 576 ? 'Add Expense' : ''}
                        >
                          <KTSVG
                            path='/media/icons/duotune/finance/fin008.svg'
                            className='svg-icon-1'
                          />
                          {onlyWidth >= 1400 || onlyWidth <= 576 ? '+' : 'Add Expenses'}
                        </a>

                        {/* Add Sale button */}
                        <a
                          className='btn btn-primary btn-sm mb-2 text-nowrap'
                          onClick={() => handleFrequentSaleClick()}
                          title={onlyWidth >= 1400 || onlyWidth <= 576 ? 'Add Sale' : ''}
                        >
                          <KTSVG
                            path='/media/icons/duotune/ecommerce/ecm001.svg'
                            className='svg-icon-1'
                          />
                          {onlyWidth >= 1400 || onlyWidth <= 576 ? '+' : 'Add Sales'}
                        </a>
                      </div>
                    </div>
                    {/* end::Search */}
                  </div>
                </div>
              </div>

              <div className='row'>
                {frequentlysolddata?.data.map((x: any) => (
                  <div className='col-6 col-xs-6  col-sm-3 col-xxl-6 fv-row mb-7'>
                    <a
                      href='#'
                      className='btn btn-icon btn-outline btn-bg-light btn-active-light-primary btn-flex flex-column flex-center w-100 h-90px border-gray-200'
                      onClick={() => handleFrequentSaleClick(x)}
                    >
                      <div className='position-relative w-100'>
                        <img
                          className='w-80px'
                          src={toAbsoluteUrl('/media/products/' + x.product_image)}
                          alt='img'
                        />
                        <div className='position-absolute bottom-0 left-0 w-100 bg-primary text-white opacity-75'>
                          <span
                            className='fs-7 fw-bold'
                            data-bs-toggle='tooltip'
                            title={`${x.product_name}`}
                          >
                            {onlyWidth <= 576
                              ? truncate(Getfirsttwowords(x.product_name), 8)
                              : truncate(Getfirsttwowords(x.product_name), 10)}{' '}
                            {Getnumbersinstring(x.product_name) > 0
                              ? Getnumbersinstring(x.product_name) + ' ' + PIC_QUANTITIES
                              : ''}
                          </span>
                        </div>
                        <div className='position-absolute top-0 w-100 d-flex justify-content-end'>
                          <div className='m-3'>
                            {' '}
                            <h2 className='badge badge-lg badge-circle badge-light-success'>
                              <span className='fs-7 fw-bold'> +{x.quantity}</span>
                            </h2>
                          </div>
                        </div>
                      </div>
                    </a>
                  </div>
                ))}
              </div>
            </KTCardBody>
          </KTCard>
        </div>

        <div className='col-xxl-8'>
          <KTCard>
            <KTCardBody className='py-4'>
              <div className='row mt-4'>
                <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'>
                  <div className='mb-2'>
                    <h3 className='fw-bolder my-2'>Sale Invoices</h3>
                  </div>
                </div>
                <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                  <div className='mb-2'>
                    {/* begin::Search */}
                    <div className='d-flex align-items-center position-relative my-1'>
                      <a href='#' onClick={handlesearchKeyDown2}>
                        <KTSVG
                          path='/media/icons/duotune/general/gen021.svg'
                          className='svg-icon-1 position-absolute me-4 top-0 end-0 mt-3 text-primary'
                        />
                      </a>
                      <input
                        type='text'
                        data-kt-user-table-filter='search'
                        className='form-control form-control-solid w-250px ps-14'
                        placeholder='Search Invoices'
                        ref={myRefsearch}
                        // value={searchTitle}
                        onChange={handleinputs}
                        onKeyDown={handlesearchKeyDown}
                      />
                    </div>
                    {/* end::Search */}
                  </div>
                </div>
              </div>

              <div className='row mt-5 mb-5'>
                <div className='col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start'></div>

                <div className='col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end'>
                  <div className='mb-2'>
                    {dayjs(dayjs().format('YYYY-MM-DD, h:mm:ss a')).unix() >=
                      dayjs(dayjs().format('YYYY-MM-DD') + OPENING_TIME).unix() ? (
                      paymenttypesinvoicedata?.data.filter(
                        (x: any) =>
                          dayjs(dayjs(x.date_payment_made).format('YYYY-MM-DD')).unix() ===
                          dayjs(dayjs().format('YYYY-MM-DD')).unix()
                      ).length > 0 ? (
                        <div className='d-flex align-items-center text-nowrap'>
                          <span className='text-primary fw-bolder fs-7 text-uppercase gs-0'>
                            Payment Mode
                          </span>
                          <span className='h-50px border-gray-200 border-start mx-2'></span>
                          <div className='d-flex justify-content-start flex-column'>
                            <span className='fw-bold d-block fs-7 text-muted'>
                              <table>
                                <tbody>
                                  {paymenttypesinvoicedata?.data
                                    .filter(
                                      (x: any) =>
                                        dayjs(
                                          dayjs(x.date_payment_made).format('YYYY-MM-DD')
                                        ).unix() === dayjs(dayjs().format('YYYY-MM-DD')).unix()
                                    )
                                    .map((k: any, keys: any) => (
                                      <tr key={keys + k.payment_type_name}>
                                        <td>
                                          <span
                                            className={`${k.payment_type_name === 'MPESA'
                                              ? 'badge badge-light-success'
                                              : k.payment_type_name === 'CHEQUE'
                                                ? 'badge badge-light-warning'
                                                : k.payment_type_name === 'MPESACASH'
                                                  ? 'badge badge-light-info'
                                                  : 'badge badge-light-primary'
                                              }`}
                                          >
                                            {k.payment_type_name}
                                          </span>
                                        </td>
                                        <td>
                                          <span className='h-20px border-gray-200 border-start mx-2'></span>
                                          <CountUp
                                            className='text-bold'
                                            end={k.total_amount_payed}
                                            duration={2}
                                            decimals={2}
                                            separator=','
                                          />{' '}
                                          <sup>{CURRENCY_APP}</sup>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </span>
                          </div>
                        </div>
                      ) : (
                        <></>
                      )
                    ) : paymenttypesinvoicedata?.data.filter(
                      (x: any) =>
                        dayjs(dayjs(x.date_payment_made).format('YYYY-MM-DD')).unix() ===
                        dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix()
                    ).length > 0 ? (
                      <div className='d-flex align-items-center text-nowrap'>
                        <span className='text-muted fw-bolder fs-7 text-uppercase gs-0'>
                          Payment Mode
                        </span>
                        <span className='h-50px border-gray-200 border-start mx-2'></span>
                        <div className='d-flex justify-content-start flex-column'>
                          <span className='fw-bold d-block fs-7 text-muted'>
                            <table>
                              <tbody>
                                {paymenttypesinvoicedata?.data
                                  .filter(
                                    (x: any) =>
                                      dayjs(
                                        dayjs(x.date_payment_made).format('YYYY-MM-DD')
                                      ).unix() ===
                                      dayjs(dayjs().subtract(1, 'days').format('YYYY-MM-DD')).unix()
                                  )
                                  .map((k: any, keys: any) => (
                                    <tr key={keys + k.payment_type_name}>
                                      <td>
                                        <span
                                          className={`${k.payment_type_name === 'MPESA'
                                            ? 'badge badge-light-success'
                                            : k.payment_type_name === 'CHEQUE'
                                              ? 'badge badge-light-warning'
                                              : k.payment_type_name === 'MPESACASH'
                                                ? 'badge badge-light-info'
                                                : 'badge badge-light-primary'
                                            }`}
                                        >
                                          {k.payment_type_name}
                                        </span>
                                      </td>
                                      <td>
                                        <span className='h-20px border-gray-200 border-start mx-2'></span>
                                        <CountUp
                                          className='text-bold'
                                          end={k.total_amount_payed}
                                          duration={2}
                                          decimals={2}
                                          separator=','
                                        />{' '}
                                        <sup>{CURRENCY_APP}</sup>
                                      </td>
                                    </tr>
                                  ))}
                              </tbody>
                            </table>
                          </span>
                        </div>
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>

              <Maintable
                tabledata={salesinvoicedsuccess ? tabledata : []}
                startlimit={startlimit}
                hiddencolumnsmade={hiddencolumnsmade}
                setstartlimit={setStartlimit}
                paginationsize={paginationsize}
                pageCount={pageCount}
                setPageCount={setPageCount}
                setPaginationsize={setPaginationsize}
                movetofirstpage={movetofirstpage}
                setMovetofirstpage={setMovetofirstpage}
                columndata={
                  onlyWidth <= 576
                    ? columndata3
                    : onlyWidth > 576 && onlyWidth <= 768
                      ? columndata5
                      : columndata1
                }
                tabledata2={tabledata}
                columndata2={
                  onlyWidth <= 576
                    ? columndata4
                    : onlyWidth > 576 && onlyWidth <= 768
                      ? columndata6
                      : columndata2
                }
                table1loaded={salesinvoicestatus === 'success'}
                table2loaded={salesinvoicestatus === 'success'}
                tablename={tablename}
                tablelength={salesinvoicestatus === 'success' ? tabledatalength : 0}
                filteredsubdata={filteredsubdata}
                filteredtablesubData={filteredtablesubData}
                setServersort={setServersort}
              />
            </KTCardBody>
          </KTCard>
        </div>
      </div>
      <Addsales
        show={modalfrequentsaleshow}
        setFrequentsaleDetails={setFrequentsaleDetails}
        handleClose={function (): void {
          setModalfrequentsaleshow(false)
          setInvoiceToAddItem(null) // Clear the invoice data
        }}
        ref={myRef2}
        isadmin={isUserAdmin()}
        frequentsaleDetails={frequentsaleDetails}
        frequentsaledoubleentry={frequentsaledoubleentry}
        setFrequentsaledoubleentry={setFrequentsaledoubleentry}
        invoiceToAddItem={invoiceToAddItem}
        mode={invoiceToAddItem ? 'add' : 'new'}
      />
      <Deleteinvoice
        show={modalshowdelete}
        deleteInvoiceSales={deleteInvoiceSales}
        invoicetodelete={invoicetodelete}
        statedeletinginvoice={statedeletinginvoice}
        handleClose={function (): void {
          setModalshowdelete(false)
        }}
      />

      <Mpesatransaction
        show={modalshowmpesa}
        mpesatransaction={mpesatransaction}
        handleClose={function (): void {
          setMpesatransaction({})
          setModalshowmpesa(false)
        }}
      />

      <Addexpenses
        show={modalshowexpenses}
        sumprofitorlossrefetch={sumprofitorlossrefetch}
        sumexpenserefetch={sumexpenserefetch}
        handleClose={function (): void {
          setModalshowexpenses(false)
        }}
        ref={myRefexpenses}
      />
      <Cashfloat
        show={modalshowcashfloat}
        handleClose={function (): void {
          setModalshowcashfloat(false)
        }}
        ref={myRefcashfloat}
        isadmin={isUserAdmin()}
      />
      <Addcustomer
        show={modalCustomershow}
        handleClose={() => setModalCustomershow(false)}
      />



      <Updateinvoice
        invoiceData={tabledata}
        show={modalshowupdate}
        invoiceupdate={invoiceupdate}
        handleClose={function (): void {
          setModalshowupdate(false)
        }}
        ref={myRefupdate}
      />
    </>
  )
}

export default Home
